module.exports = __webpack_public_path__ + "img/departure-detail.fe4e2646.svg";